import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface XYFadeProps {
  children: ReactNode;
  className?: string;
  fadeHeight?: number;
  fadeColor?: string; // CSS custom property name (e.g., "var(--background)", "var(--primary)")
  direction?: "vertical" | "horizontal" | "both";
}

export function XYFade({
  children,
  className,
  fadeHeight = 20,
  fadeColor = "var(--background)",
  direction = "vertical",
}: XYFadeProps): JSX.Element {
  const fadeStyle = {
    height: fadeHeight,
    background: `linear-gradient(to bottom, ${fadeColor}, transparent)`,
  };

  const bottomFadeStyle = {
    height: fadeHeight,
    background: `linear-gradient(to top, ${fadeColor}, transparent)`,
  };

  const horizontalFadeStyle = {
    width: fadeHeight,
    background: `linear-gradient(to right, ${fadeColor}, transparent)`,
  };

  const horizontalBottomFadeStyle = {
    width: fadeHeight,
    background: `linear-gradient(to left, ${fadeColor}, transparent)`,
  };

  return (
    <div className={cn("relative overflow-hidden", className)}>
      {/* Top fade overlay */}
      {direction === "vertical" || direction === "both" ? (
        <div
          className="pointer-events-none absolute top-0 right-0 left-0 z-10"
          style={fadeStyle}
        />
      ) : null}

      {/* Bottom fade overlay */}
      {direction === "vertical" || direction === "both" ? (
        <div
          className="pointer-events-none absolute right-0 bottom-0 left-0 z-10"
          style={bottomFadeStyle}
        />
      ) : null}

      {/* Left fade overlay */}
      {direction === "horizontal" || direction === "both" ? (
        <div
          className="pointer-events-none absolute top-0 bottom-0 left-0 z-10"
          style={horizontalFadeStyle}
        />
      ) : null}

      {/* Right fade overlay */}
      {direction === "horizontal" || direction === "both" ? (
        <div
          className="pointer-events-none absolute top-0 right-0 bottom-0 z-10"
          style={horizontalBottomFadeStyle}
        />
      ) : null}

      {/* Content - centered */}
      <div className="relative z-0 flex min-h-full items-center justify-center">
        {children}
      </div>
    </div>
  );
}
